import { gql, useQuery } from '@apollo/client';
import { ExchangeRates } from './index.types';

const query = gql`
  query ExchangeRates {
    clearing {
      RUBUSD: exchangeRate(exchangeRate: { from: "RUB", to: "USD" })
      USDRUB: exchangeRate(exchangeRate: { from: "USD", to: "RUB" })
    }
  }
`;

export const useExchangeRate = () => {
  const { data } = useQuery<ExchangeRates>(query);
  return {
    RUBUSD: data?.clearing?.RUBUSD,
    USDRUB: data?.clearing?.USDRUB,
  };
};
